export const matchesUrlPatterns = (pathname: string, patterns: string[]): boolean => {
  if (patterns.length === 0) return true;
  return patterns.some((pattern) => {
    // "/v2/ask/*" should match "/v2/ask", "/v2/ask/", and "/v2/ask/anything"
    const normalized = pattern.replace(/\/\*$/, "(/.*)?");
    const regex = new RegExp("^" + normalized.replace(/\*/g, ".*") + "$");
    return regex.test(pathname);
  });
};
